import React from "react";

export const SmallCircleCross = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <g clipPath="url(#clip0_7308_9942)">
      <path
        d="M6.98633 0.5C3.67262 0.5 0.986328 3.18629 0.986328 6.5C0.986328 9.81371 3.67262 12.5 6.98633 12.5C10.3 12.5 12.9863 9.81371 12.9863 6.5C12.9827 3.18777 10.2986 0.503586 6.98633 0.5ZM8.98632 7.79349C9.1895 7.9805 9.20263 8.29681 9.01562 8.49999C8.82861 8.70317 8.5123 8.7163 8.30912 8.52929C8.29895 8.51994 8.2892 8.51016 8.27982 8.49999L6.98633 7.20699L5.69333 8.49999C5.4947 8.69183 5.17817 8.68632 4.98634 8.48769C4.79921 8.29393 4.79921 7.98676 4.98634 7.793L6.27934 6.5L4.98634 5.207C4.7945 5.00837 4.80001 4.69184 4.99864 4.50001C5.1924 4.31288 5.49957 4.31288 5.69333 4.50001L6.98633 5.79301L8.27982 4.50001C8.46683 4.29683 8.78314 4.2837 8.98632 4.47071C9.1895 4.65772 9.20263 4.97403 9.01562 5.17721C9.00627 5.18738 8.99649 5.19713 8.98632 5.20651L7.69332 6.5L8.98632 7.79349Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7308_9942">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0.986328 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
